// services/authContracts.ts

/**
 * Ora's own session routes on the ORA-986 backend (ORA-987), kept in one
 * place so a rename on the backend is a one-line fix here. The native
 * deep-link contract lives in `nativeAuthReturn.ts`.
 *
 * All are legacy-style ora-be routes (no `/api/auth` prefix), authenticated
 * by the Better Auth session cookie only (a bearer token gets 401 "A session
 * cookie is required").
 */

/**
 * Body `{ userId }`, plus the admin step-up header the axios client
 * attaches. Swaps the admin's session cookie for one acting as the student.
 * Response `{ success, data: { userId, impersonatedBy } }`; 403
 * `ADMIN_STEP_UP_REQUIRED` (prompted and replayed by axios) or
 * `ADMIN_TARGET_FORBIDDEN`.
 */
export const IMPERSONATE_SESSION_PATH = '/auth/impersonate-session';

/**
 * No body. Restores the admin's own session cookie. Response
 * `{ success, data: { userId } }` (the admin's id).
 */
export const STOP_IMPERSONATING_PATH = '/auth/stop-impersonating';

/**
 * Body `{ newPassword }` (8–128 characters). Adds an email + password
 * credential to an account that only signs in with Google or Apple.
 * Response `{ success: true }`; 409 "Password already set".
 */
export const SET_PASSWORD_PATH = '/auth/set-password';

/**
 * Exists on the backend branch (not provisional): applies sign-in context
 * (unlock cohort, unlock email, UTM attribution) after a sign-in whose
 * context could not ride along, i.e. one finished on the 2FA page or with a
 * passkey.
 */
export const APPLY_SIGNIN_CONTEXT_PATH = '/auth/apply-signin-context';
